<template>
  <v-expansion-panel>
    <v-expansion-panel-header disable-icon-rotate>
      {{ label }}
      <template v-slot:actions>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" :color="getIconColor(selected.status)" left>{{ getIcon(selected.status) }}</v-icon>
          </template>
          <span v-if="selected.status === 'Complete'">Section has been completed</span>
          <span v-else-if="selected.status === 'In-Progress'">Section is in progress</span>
          <span v-else-if="selected.status === 'Ready'">Section available but not started</span>
          <span v-else>Section is currently locked</span>
        </v-tooltip>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-list v-if="selected && 'slides' in selected">
          <tracker-slide
            v-for="({ name, seen, types, blocks }, slideIndex) in selected.slides"
            :key="'slide-' + slideIndex"
            :name="name"
            :seen="seen"
            :types="types"
            :blocks="blocks">
          </tracker-slide>
        </v-list>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
export default {
  props: {
    studentName: String,
    code: String,
    label: String,
    slides: Array,
    selected: Object
  },
  components: {
    TrackerSlide: () => import('./slide')
  },
  setup (props) {
    function getIconColor (status) {
      switch (status) {
        case 'Locked':
          return 'error'
        case 'Complete':
          return 'success'
      }
      return ''
    }

    function getIcon (status) {
      switch (status) {
        case 'Locked':
          return 'fal fa-lock'
        case 'Ready':
          return 'fal fa-play'
        case 'In-Progress':
          return 'fal fa-arrow-alt-circle-right'
        case 'Complete':
          return 'fas fa-check'
      }
    }

    return {
      getIconColor,
      getIcon
    }
  }
}
</script>
